"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _reactrouterdom = require('react-router-dom');

const ROUTES = {
  ROOT: '/',
  LOGIN: {
    ROOT: '/login',
    EMAIL_LOGIN: '/login/email/:email',
    FORGOT_PASSWORD: '/login/reset-password',
    RESET_PASSWORD: '/login/reset-password/:token?',
    EXPIRED_PASSWORD: '/login/expired-password',
  },
  INBOX: {
    ROOT: '/inbox',
    NEW: '/inbox/new/:createdChatType?',
    CHAT: '/inbox/:blobjectKey?/:wrappedTypePrefix?/:wrappedKey?',
  },
  BROADCAST: {
    ROOT: '/broadcast',
    NEW_CAMPAIGN: '/broadcast/new',
    CAMPAIGN_WIZARD: '/broadcast/:campaignKey/edit/:step',
    CAMPAIGN_PAGE: '/broadcast/:campaignKey',
  },
  DIRECTORY: {
    ROOT: '/directory',
    ENTITY: '/directory/:typePrefix?/:orgKey?/:entityKey?',
    TEAM_PAGE: '/directory/t/:orgKey/:teamKey',
    USER_PAGE: '/directory/u/:orgKey/:userKey',
    PATIENT_PAGE: '/directory/p/:orgKey/:patientKey',
  },
  VIDEO: {
    ROOT: '/vd',
    V1: '/video/:videoKey/:userKey?',
    V2: '/vd/:blobjectKey?',
  },
  CONFIRM_EMAIL: '/confirm_email/:token',
  UNSUBSCRIBE: {
    EMAIL: '/unsubscribe_notifs/:email/:token',
  },
  CODE: '/code',
  WELCOME: '/welcome',
  CREATE_ACCOUNT: '/welcome/:token?',
  ONBOARDING_PAYMENT: '/onboarding-payment/:status?',
  ONBOARDING_DEMO: '/onboarding-demo',
  ONBOARDING_STEPS: '/onboarding-steps',
  SETTINGS: {
    ROOT: '/settings',
    PROFILE: '/settings/profile',
    SECURITY: '/settings/security',
    NOTIFICATIONS: '/settings/notifications',
    // Old link: templates moved to the chat's Templates dialog.
    TEMPLATES: '/settings/templates',
    ORGS: '/settings/orgs',
    ORG_PAGE: '/settings/orgs/:orgKey/:tabName',
    ORG_PAGE_NO_TAB: '/settings/orgs/:orgKey',
    ORG_PAGE_DEFAULT_TAB: '/settings/orgs/:orgKey/members',
    // An account is named by any of its orgs, usually its default org.
    ACCOUNT: '/settings/account',
    ACCOUNT_PAGE: '/settings/account/:orgKey/:tabName?',
  },
  SUPER: '/super',
  // Staff Forms, behind the org's FORMS feature. The family's page is
  // /form/F{code} (singular), its own app mode.
  FORMS: {
    ROOT: '/forms',
    SENT: '/forms/sent',
    SENT_FORM: '/forms/sent/:code',
    SCAN: '/forms/scan/:orgKey/:formKey?',
    EDITOR: '/forms/:orgKey/:formKey',
  },
}

 const makeRoute = _reactrouterdom.generatePath; exports.makeRoute = makeRoute

// Query param on a team page naming the chat it was opened from.
 const TEAM_PAGE_CONVERSATION_PARAM = 'conversationKey'; exports.TEAM_PAGE_CONVERSATION_PARAM = TEAM_PAGE_CONVERSATION_PARAM
// Query param on a person's page naming the chat (blobject) it was opened from.
 const USER_PAGE_CHAT_PARAM = 'chatKey'; exports.USER_PAGE_CHAT_PARAM = USER_PAGE_CHAT_PARAM

// Query param on Settings → Account → Audit naming the patient to filter to.
 const AUDIT_PATIENT_PARAM = 'patient'; exports.AUDIT_PATIENT_PARAM = AUDIT_PATIENT_PARAM

exports. default = ROUTES
